import { CONNECT_DRAWER_TO_PRINTER } from 'constants/settings'

export default function ConnectDrawerToPrinter(printer) {
  return {
    type: CONNECT_DRAWER_TO_PRINTER,
    printer,
  }
}